import { render, staticRenderFns } from "./PositionedPins.vue?vue&type=template&id=9a50058e&scoped=true&"
import script from "./PositionedPins.vue?vue&type=script&lang=js&"
export * from "./PositionedPins.vue?vue&type=script&lang=js&"
import style0 from "./PositionedPins.vue?vue&type=style&index=0&id=9a50058e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a50058e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a50058e')) {
      api.createRecord('9a50058e', component.options)
    } else {
      api.reload('9a50058e', component.options)
    }
    module.hot.accept("./PositionedPins.vue?vue&type=template&id=9a50058e&scoped=true&", function () {
      api.rerender('9a50058e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/FIlesPreviewer/components/PinsAnnotations/PositionedPins.vue"
export default component.exports